import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * 用語集の1エントリを表す型
 */
export type GlossaryRow = {
  /** 言語コード（例: jpn, eng-US） */
  language: string;
  /** 単語 */
  content: string;
  /** 読み仮名・発音ガイドのリスト */
  soundsLike: string[];
};

/**
 * 用語集の登録内容を管理 State
 */
export type GlossaryEntriesState = {
  // 登録済みの用語集エントリ
  entries: GlossaryRow[];
};

/**
 * 初期State
 */
const initialState: GlossaryEntriesState = {
  entries: [],
};

/**
 * 用語集の登録内容を管理 Slice
 */
export const glossaryEntriesSlice = createSlice({
  name: 'glossaryEntries',
  initialState,
  reducers: {
    // 用語集を全件置き換え
    setGlossaryEntries: (state, action: PayloadAction<GlossaryRow[]>) => {
      state.entries = action.payload;
    },
    // 初期化
    clearGlossaryEntries: () => initialState,
  },
});
